import Map from './Map';
import reducer from './reducer';

const Schedule = {
  List: Map,
  reducer
};

export default Schedule;
